export default __webpack_public_path__ + "static/media/close-x.4d6cefc5.svg";